import React, { PropTypes } from "react";
import validate from "validate.js";
import Input, { InputLabel } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import { FormControl, FormHelperText } from "material-ui/Form";
import Select from "material-ui/Select";
import classNames from "classnames";

const SelectField = ({
  field_name,
  value,
  className,
  onChange,
  label,
  errors,
  options,
  multiple,
  disabled,
}) => {
  return (
    <div className={classNames(className, "form-control-select")}>
      <FormControl style={{ width: "100%", textAlign: "left" }}>
        <InputLabel
          htmlFor={`${field_name}_field`}
          error={errors && errors.length}
        >
          {label}
        </InputLabel>
        <Select
          multiple={multiple}
          value={value}
          error={errors && errors.length}
          onChange={onChange}
          disabled={disabled}
          inputProps={{
            name: field_name,
            id: `${field_name}_field`,
          }}
        >
          {options.map((item) => (
            <MenuItem value={item.value}> {item.label}</MenuItem>
          ))}
        </Select>
        {(errors || [])[0] && (
          <FormHelperText
            id="weight-helper-text"
            error={errors && errors.length}
          >
            {(errors || [])[0]}
          </FormHelperText>
        )}
      </FormControl>
    </div>
  );
};

SelectField.propTypes = {
  field_name: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  errors: PropTypes.oneOfType([PropTypes.array, null]),
  options: PropTypes.array,
};

export default SelectField;



// WEBPACK FOOTER //
// ./src/components/InputField/SelectField.jsx